import React, { useState } from 'react';

import { FaEye, FaEyeSlash } from 'react-icons/fa';

function RenderFieldInput({
  input,
  type,
  className,
  disabled,
  placeholder,
  meta: { touched, error },
}) {
  const [typeInput, setTypeInput] = useState(type);

  return (
    <div className="position-relative">
      <input
        {...input}
        type={typeInput}
        disabled={disabled}
        className={className}
        placeholder={placeholder}
        style={{ paddingRight: type === 'password' ? '2rem' : '.75rem' }}
      />
      {type === 'password' && (
        <span
          className="position-absolute"
          style={{ top: '5px', right: '10px' }}
          onClick={() =>
            setTypeInput(typeInput === 'text' ? 'password' : 'text')
          }
        >
          {typeInput === 'text' ? <FaEye /> : <FaEyeSlash />}
        </span>
      )}
      {touched && error && (
        <div
          style={{
            color: '#FF0000',
            margin: '0 0 10px',
            fontSize: '0.75rem',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
}

export default RenderFieldInput;
